export const EmailTypes = {
  // mover related:
  stripeSignup: "STRIPE_SIGNUP",

  // request related:
  feedback: "FEEDBACK",
};